/**
 * Listing <title> — one formula for pages/buyer/VehicleDetail.js (runtime) and
 * scripts/inject-seo-heads.js (build). Two copies of this formula is how the
 * crawler and the visitor end up reading different titles.
 *
 * Measured 2026-09-23: the previous form —
 *   "2018 Maruti Suzuki Swift Dzire Tour S CNG – ₹3,70,000 – 97,000 km – Used
 *    Taxi in Gurugram"
 * — ran 85–89 characters, so Google cut it around "₹3,70,00…" and the buyer
 * never saw the odometer or the city. Three things were spending characters
 * without earning them: full rupee digits (₹3,70,000 → ₹3.7L), full odometer
 * digits (97,000 km → 97k km) and the words "Used Taxi in" before the city.
 *
 * The odometer STAYS. Without it, near-identical listings collided outright —
 * four groups covering nine pages shared a byte-identical title (three 2024
 * Innova Crystas in New Delhi at ₹14,99,000, two Gurugram Ertigas at ₹7,99,000).
 * It is also the first number a taxi buyer looks for. All 78 live listings come
 * out unique under this formula; median 50 characters.
 *
 * Keep the file import-free and every declaration a top-level export — the
 * injector loads it by stripping the `export` keywords.
 */

// ₹3,70,000 -> "3.7L". Indian buyers read lakhs, and it costs 4 fewer characters.
export function priceLakh(value) {
  const n = Number(value);
  if (!isFinite(n) || n <= 0) return '';
  return `${(n / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
}

// 97000 -> "97k km"; anything under 1,000 stays exact.
export function kmShort(value) {
  const n = Number(value);
  if (!isFinite(n) || n <= 0) return '';
  return n >= 1000 ? `${Math.round(n / 1000)}k km` : `${n} km`;
}

export const VEHICLE_TITLE_LIMIT = 60;

export function vehicleTitle(v) {
  const build = (brand) => {
    const head = [v.year, brand, v.model].filter(Boolean).join(' ');
    const price = priceLakh(v.price_final);
    const tail = [price && `₹${price}`, kmShort(v.km_run), v.city].filter(Boolean).join(', ');
    return tail ? `${head} ${tail}` : `${head} – Used Taxi for Sale`;
  };
  const full = build(v.brand);
  if (full.length <= VEHICLE_TITLE_LIMIT || !v.brand || !/\s/.test(v.brand)) return full;
  // Only the longest Maruti Suzuki model names overflow. "Maruti Dzire" is how
  // the cars are spoken about and searched for anyway, and the full brand name
  // is still in the h1, the description and the Product schema.
  const short = build(String(v.brand).split(/\s+/)[0]);
  return short.length < full.length ? short : full;
}
